/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    saveHRPolicy(payload) {
        return HttpService.put(environment.API_HR_PRIVACY_POLICY, payload);
    },
    searchHRPolicy(dataTypeId) {
        return HttpService.get(
            environment.API_HR_PRIVACY_POLICY +
                `?dataSubjectTypeIds=${dataTypeId}`
        );
    },
    getHRPolicyDetail(policyId) {
        return HttpService.get(
            environment.API_HR_PRIVACY_POLICY + `/${policyId}`
        );
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_HR_PRIVACY_POLICY + `/publish-version/` + id
        );
    },
    getHRPolicyDetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_HR_PRIVACY_POLICY_PUBLIC +
                `/publish-version/${policyId}`
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(environment.API_HR_PRIVACY_POLICY + `/history`, {
            params,
        });
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_HR_PRIVACY_POLICY + `/history/detail`,
            {
                params,
            }
        );
    },
    deleteHRPolicy(policyId) {
        return HttpService.delete(
            environment.API_HR_PRIVACY_POLICY + `/${policyId}`
        );
    },
    renameHRPolicy(payload) {
        return HttpService.put(
            environment.API_HR_PRIVACY_POLICY + `/rename`,
            payload
        );
    },
};
